import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LOCATION_CHANGE } from 'redux-first-history';

const LocationLogger = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Every time the location changes,
    // manually dispatch the LOCATION_CHANGE action.
    dispatch({
      type: LOCATION_CHANGE,
      payload: { location },
    });
  }, [location, dispatch]);

  return (
    <> </>
  );
};

export default LocationLogger;
